import React, { useState, useRef, useEffect } from "react";
import "../Gallery/Gallery.css";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";

const Gallery = () => {

const [events,setEvents] = useState([]);

const [eventIndex,setEventIndex] = useState(0);
const [mediaIndex,setMediaIndex] = useState(0);
const [showModal,setShowModal] = useState(false);

const scrollRef = useRef(null);
const thumbRef = useRef(null);

/* LOAD DATA FROM MYSQL */

useEffect(()=>{

axios.get("/api/gallery")
.then(res=>{

    axios.get("/api/gallery")
    .then(res=>{
    
    const formatted = res.data.map(event=>({
    eventCode:event.id,
    image_header:event.event_title,
    image_descr:event.event_description,
    imgdate:event.event_date,
    eventplace:event.event_place,
    category:event.event_category,
    year:new Date(event.event_date).getFullYear(),
    
    image_main:
    event.main_image
    ? `${BASE_URL}/uploads/gallery/${event.main_image}`
    : "",
    
    image_more:
    event.images
    ? event.images.map(img=>`${BASE_URL}/uploads/gallery/${img.image_path}`)
    : []
    
    }));
    
    /* SORT LATEST EVENT FIRST */
    
    formatted.sort((a,b)=> new Date(b.imgdate) - new Date(a.imgdate));
    
    setEvents(formatted);
    
    })
})
.catch(err=>{

console.log("Gallery Load Error:",err);

});

},[]);

const currentEvent = events[eventIndex];

/* MEDIA LIST */

let mediaList=[];

if(currentEvent){
if(currentEvent.image_main){
mediaList.push(currentEvent.image_main);
}
if(currentEvent.image_more){
mediaList=mediaList.concat(currentEvent.image_more);
}
}

/* VIDEO CHECK */

const isVideo=(file)=>{
if(!file) return false;
return file.toLowerCase().match(/\.(mp4|webm|ogg)$/);
};

/* DATE */

const formatDate=(date)=>{
return new Date(date).toLocaleDateString("en-US",{
year:"numeric",
month:"long",
day:"numeric"
});
};

/* NAVIGATION */

const nextMedia=()=>{
setMediaIndex(prev=> prev<mediaList.length-1 ? prev+1 : prev);
};

const prevMedia=()=>{
setMediaIndex(prev=> prev>0 ? prev-1 : prev);
};

/* KEYBOARD NAVIGATION */

useEffect(()=>{

const keyHandler=(e)=>{

if(e.key==="ArrowRight") nextMedia();
if(e.key==="ArrowLeft") prevMedia();
if(e.key==="Escape") setShowModal(false);

};

window.addEventListener("keydown",keyHandler);

return ()=> window.removeEventListener("keydown",keyHandler);

});

/* SELECT EVENT */

const selectEvent=(index)=>{
setEventIndex(index);
setMediaIndex(0);
};

/* SCROLL */

const scrollUp=()=>{
scrollRef.current.scrollBy({top:-200,behavior:"smooth"});
};

const scrollDown=()=>{
scrollRef.current.scrollBy({top:200,behavior:"smooth"});
};

const thumbLeft=()=>{
thumbRef.current.scrollBy({left:-200,behavior:"smooth"});
};

const thumbRight=()=>{
thumbRef.current.scrollBy({left:200,behavior:"smooth"});
};

/* MEDIA RENDER */

const renderMedia=(file,className="viewer-media")=>{

if(isVideo(file)){
return(
<video src={file} className={className} controls/>
);
}

return(
<img src={file} className={className} loading="lazy" alt=""/>
);

};

return(

<section className="gallery-page">

<div className="container">

{/* HEADER */}

<div className="gallery-header text-center">

<h2>SCHOOL MEMORIES - PHOTO & VIDEO GALLERY</h2>

<p className="header-text">
Celebrating Festivals, Achievements and Unforgettable Moments.
</p>

</div>

<div className="row gallery-row">

{/* LEFT PANEL */}

<div className="col-xl-3 col-lg-4 col-md-5 gallery-left">

<button className="arrow-btn" onClick={scrollUp}>▲</button>

<div className="event-list" ref={scrollRef}>

{events.map((event,index)=>(

<div
key={event.eventCode}
className={index===eventIndex ? "event-item active":"event-item"}
onClick={()=>selectEvent(index)}
>

<img src={event.image_main} alt=""/>

<div className="event-text">

<h6>{event.image_header}</h6>

<div className="event-meta">
{event.year} | {formatDate(event.imgdate)} | {event.category}
</div>

</div>

</div>

))}

</div>

<button className="arrow-btn" onClick={scrollDown}>▼</button>

</div>

{/* RIGHT PANEL */}

<div className="col-xl-9 col-lg-8 col-md-7 gallery-right">

{/* MAIN VIEWER */}

<div className="media-viewer">

<button className="nav-btn left" onClick={prevMedia}>‹</button>

<div
className="viewer-box"
onClick={()=>setShowModal(true)}
>

{renderMedia(mediaList[mediaIndex])}

</div>

<button className="nav-btn right" onClick={nextMedia}>›</button>

</div>

{/* THUMBNAILS */}

<div className="thumb-container">

{mediaList.length>8 &&
<button className="thumb-arrow" onClick={thumbLeft}>‹</button>
}

<div className="thumb-strip" ref={thumbRef}>

{mediaList.map((file,i)=>(

<div
key={i}
className="thumb-box"
onClick={()=>setMediaIndex(i)}
>

{isVideo(file)

?

<video
src={file}
className={i===mediaIndex?"thumb active":"thumb"}
/>

:

<img
src={file}
className={i===mediaIndex?"thumb active":"thumb"}
alt=""
/>

}

</div>

))}

</div>

{mediaList.length>8 &&
<button className="thumb-arrow" onClick={thumbRight}>›</button>
}

</div>


{/* EVENT DETAILS */}
<div className="event-details">
<h3>{currentEvent ? currentEvent.image_header : ""}</h3>
<p className="descr">{currentEvent ? currentEvent.image_descr : ""}</p>
<div className="details-grid">
<div>📅 {currentEvent ? formatDate(currentEvent.imgdate) : ""}</div>
<div>📍 {currentEvent ? currentEvent.eventplace : ""}</div>
</div>
</div>

{/* MASONRY GRID */}

<div className="masonry-grid">

{mediaList.map((file,i)=>(

<div key={i} className="masonry-item">

{isVideo(file)

?

<video src={file} controls/>

:

<img src={file} loading="lazy" alt=""/>

}

</div>

))}

</div>

</div>

</div>

</div>

{/* FULLSCREEN MODAL */}

{showModal &&(

<div
className="image-modal"
onClick={()=>setShowModal(false)}
>

<button
className="nav-btn left"
onClick={(e)=>{e.stopPropagation();prevMedia();}}
>‹</button>

{renderMedia(mediaList[mediaIndex],"modal-media")}

<button
className="nav-btn right"
onClick={(e)=>{e.stopPropagation();nextMedia();}}
>›</button>

</div>

)}

</section>

);

};

export default Gallery;